import { render } from "./DeleteFileButton.vue?vue&type=template&id=2fb4b386&ts=true"
import script from "./DeleteFileButton.vue?vue&type=script&lang=ts"
export * from "./DeleteFileButton.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__